export default {
  root: {
    position: 'absolute',
    top: 37,
    left: 'calc(100% + 10px)',
    '& svg': {
      fill: '#0070b9'
    }
  }
};
